<template>
  <div>
    <input
      type="radio"
      :value="percentage"
      :id="getId"
      :disabled="disabled"
      name="percentage"
      @change="$emit('update:modelValue', $event.target.value)"
    />
    <label :for="getId">{{ percentage }}%</label>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'percentage-button',
  props: {
    modelValue: String,
    percentage: { type: Number, required: true },
    disabled: Boolean,
  },
  emits: ['update:modelValue'],
  computed: {
    getId(): string {
      return `${this.percentage}%`;
    },
  },
});
</script>

<style lang="scss" scoped>
div {
  border-radius: 0.3rem;
  display: flex;
  justify-content: center;
  align-items: stretch;
}

input {
  display: none;
}

input:checked + label {
  color: $darkest-cyan;
  background-color: $primary-cyan;
}

input:disabled + label {
  background-color: $light-cyan;
  color: $white;
  cursor: default;
}

label {
  text-align: center;
  border: none;

  font-family: inherit;
  font-weight: 700;
  color: $white;

  cursor: pointer;
  transition: all 0.2s;

  width: 100%;
  padding: 0.25rem 1.5rem;
  border-radius: 0.3rem;
  background-color: $darkest-cyan;

  &:hover {
    background-color: lighten($color: $darkest-cyan, $amount: 7);
  }
}
</style>
